import { render, staticRenderFns } from "./GeneratedContent.vue?vue&type=template&id=64108a12&"
import script from "./GeneratedContent.vue?vue&type=script&lang=js&"
export * from "./GeneratedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports